import { init, thumbnailDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

if(!window.location.href.includes("/collections/vendors")){
    init({
        ...window.nostoTemplatesConfig,
        serpComponent: Serp,
        historyComponent: History,
        autocompleteComponent: Autocomplete,
        categoryComponent: Category,
        inputCssSelector: ".live-search-form input",
        contentCssSelector: ".productgrid--outer",
        formCssSelector: ".live-search-form",
        dropdownCssSelector: ".site-header-main-content",
        hitDecorators: [
            thumbnailDecorator({ size: "9" })
        ],
        serpUrlMapping: {
            query: "q",
            "products.filter": "filter",
            "products.page": "page",
            "products.sort": "sort"
        },
        // Uncomment to redirect to search page instead of rendering on the same page
        serpPath: '/search',

        // Uncomment to redirect to search page instead of rewriting browser history
        serpPathRedirect: true,
        serpQuery: {
            products: {
                facets: ["*"],
                size: defaultConfig.serpSize,
                from: 0
            }
        },
        autocompleteQuery: {
            products: {
                fields: [
                    "productId",
                    "url",
                    "name",
                    "imageUrl",
                    "thumbUrl",
                    "brand",
                    "availability",
                    "price",
                    "priceText",
                    "listPrice",
                    "ratingValue",
                    "reviewCount",
                    "tags1",
                    "onDiscount"
                ],
                size: defaultConfig.autocompleteProductsSize
            },
            keywords: {
                fields: ["keyword", "_highlight.keyword"],
                size: defaultConfig.autocompleteKeywordsSize,
                facets: ["*"]
            }
        },
        compressUrlParameters: true,
        fallback: true,
        // // Uncomment for Category Merchandising
        categoryCssSelector: '.productgrid--outer',
        categoryQuery() {
            return {
                name: 'serp',
                products: {
                    categoryId: this.categoryId(),
                    categoryPath: this.categoryPath(),
                    size: defaultConfig.serpSize,
                    from: 0,
                }
            }
        },
    })
}
